export default "__VITE_ASSET__DU_y0eEY__"